module.exports = "<div class=\"row\">\r\n  <div class=\"col-xs-12 col-sm-12 col-lg-12\">\r\n     sesión terminada\r\n  </div>\r\n</div>\r\n<app-loading [loading]=\"loading\"></app-loading>"


//////////////////
// WEBPACK FOOTER
// ./src/app/session/terminar/sessionterminar.component.html
// module id = ./src/app/session/terminar/sessionterminar.component.html
// module chunks = main